import React from 'react';
import { Link } from 'react-router-dom';
import { PawPrint, ArrowRight } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="not-found-page">
      <div className="w-16 h-16 rounded-full bg-[#F0F5EF] flex items-center justify-center mx-auto mb-6">
        <PawPrint className="w-8 h-8 text-[#2A5C43]" />
      </div>
      <p className="text-xs tracking-[0.3em] uppercase text-[#D47A4A] font-semibold mb-2">Error 404</p>
      <h1 className="font-display font-bold text-3xl sm:text-4xl text-[#1C1917] mb-3">Esta página se escapó</h1>
      <p className="text-[#57534E] mb-8">No encontramos lo que buscas, pero tenemos mucho alimento rico esperándote.</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/perros" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2A5C43] text-white px-6 h-12 font-semibold" data-testid="not-found-dogs">
          Alimento para perros <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/gatos" className="inline-flex items-center justify-center gap-2 rounded-full border border-[#2A5C43] text-[#2A5C43] px-6 h-12 font-semibold" data-testid="not-found-cats">
          Alimento para gatos
        </Link>
      </div>
    </div>
  );
}
